import { render, staticRenderFns } from "./BuildingsOverviewSide.vue?vue&type=template&id=7dbc2b10&scoped=true"
import script from "./BuildingsOverviewSide.vue?vue&type=script&lang=js"
export * from "./BuildingsOverviewSide.vue?vue&type=script&lang=js"
import style0 from "./BuildingsOverviewSide.vue?vue&type=style&index=0&id=7dbc2b10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbc2b10",
  null
  
)

export default component.exports